/**
 * The key to the shot colours (owner, 2026-09-25): what green, gold, grey and red mean.
 * One source for the results screen and How to play, so they can never disagree.
 */
import { SHARE, SHOT_KEY } from '../config/site.ts';
import type { ShotMark } from './share.ts';

/** In the order the key reads: the SHARE table's own order. */
export const SHOT_MARKS = Object.keys(SHARE.shotEmoji) as ShotMark[];

/** One coloured dot, as drawn in the row of shots. Decorative: the label carries it. */
export function shotDot(mark: ShotMark): HTMLSpanElement {
  const dot = document.createElement('span');
  dot.className = `shot-dot shot-dot--${mark}`;
  dot.setAttribute('aria-hidden', 'true');
  return dot;
}

export function createShotKey(): HTMLUListElement {
  const list = document.createElement('ul');
  list.className = 'shot-key';
  for (const mark of SHOT_MARKS) {
    const item = document.createElement('li');
    item.className = 'shot-key__item';
    const label = document.createElement('span');
    label.textContent = SHOT_KEY[mark];
    item.append(shotDot(mark), label);
    list.append(item);
  }
  return list;
}
